import dashboardApi from 'services/api/dashboard'

import {
  invoiceStatusesAcceptableForBalanceCalculation,
  invoiceStatusesAcceptableForTotalDueCalculation
} from '../features/Billing/statusNames'
import * as a from './actionTypes'

function calculateActiveBalance(invoiceData) {
  const activeBalance = invoiceData.billingSummary.invoices.reduce(
    (prev, curr) =>
      invoiceStatusesAcceptableForBalanceCalculation.includes(curr.status)
        ? prev + curr.totalAmountDueRemaining
        : prev,
    0
  )

  return activeBalance
}

function calculateTotalDue(invoiceData) {
  const totalDue = invoiceData.billingSummary.invoices
    .filter(i => invoiceStatusesAcceptableForTotalDueCalculation.includes(i.status))
    .reduce((a, b) => a + b.totalAmountDueRemaining, 0)

  return totalDue
}

export const getInvoicesList = isGroupView => {
  return async dispatch => {
    dispatch({
      type: a.GET_INVOICES_LIST_STARTED
    })

    try {
      const invoiceData = await dashboardApi.getInvoiceList(isGroupView)

      const invoices = invoiceData.billingSummary.invoices
      const totalDue = calculateTotalDue(invoiceData)
      const activeBalance = calculateActiveBalance(invoiceData)
      const merchantName = invoiceData.merchantName
      const currentBalance = invoiceData.billingSummary.currentBalance
      const reconciliationDueDate = invoiceData.reconciliationDueDate

      dispatch({
        type: a.GET_INVOICES_LIST_SUCCESS,
        payload: {
          invoices,
          totalDue,
          activeBalance,
          merchantName,
          currentBalance,
          reconciliationDueDate
        }
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: a.GET_INVOICES_LIST_FAILED,
        payload: err.toString()
      })
    }
  }
}

export const getPaymentsList = isGroupView => {
  return async dispatch => {
    dispatch({
      type: a.GET_PAYMENT_LIST_STARTED
    })

    try {
      const response = await dashboardApi.getPaymentsList(isGroupView)
      dispatch({
        type: a.GET_PAYMENT_LIST_SUCCESS,
        payload: response
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: a.GET_PAYMENT_LIST_FAILED,
        payload: err.toString()
      })
    }
  }
}

export const sendInvoice = (contactData, isForGroup) => {
  return async dispatch => {
    dispatch({
      type: a.SEND_INVOICE_STARTED
    })

    try {
      const res = await dashboardApi.sendInvoice({ ...contactData, isForGroup: false })
      dispatch({
        type: a.SEND_INVOICE_SUCCESS,
        payload: res
      })
      dispatch(getInvoicesList(isForGroup))
    } catch (error) {
      dispatch({
        type: a.SEND_INVOICE_FAILED,
        payload: error.toString()
      })
    }
  }
}

export const getInvoiceContacts = isGroupLevel => {
  return async dispatch => {
    dispatch({
      type: a.GET_BILLING_CONTACTS_STARTED
    })

    try {
      const res = await dashboardApi.getBillingContacts(isGroupLevel)
      dispatch({
        type: a.GET_BILLING_CONTACTS_SUCCESS,
        payload: res
      })
    } catch (error) {
      dispatch({
        type: a.GET_BILLING_CONTACTS_FAILED
      })
    }
  }
}

export const postPaymentRetry = (id, isGroupLevel) => {
  return async dispatch => {
    dispatch({
      type: a.RETRY_PAYMENT_STARTED
    })

    try {
      await dashboardApi.retryPayment(id)
      dispatch({
        type: a.RETRY_PAYMENT_SUCCESS
      })
      dispatch(getPaymentsList(isGroupLevel))
    } catch (error) {
      dispatch({
        type: a.RETRY_PAYMENT_FAILED
      })
    }
  }
}

export const updatePayment = (model, isGroupLevel) => {
  return async dispatch => {
    dispatch({
      type: a.UPDATE_PAYMENT_STARTED
    })

    try {
      await dashboardApi.updatePayment(model)
      dispatch({
        type: a.UPDATE_PAYMENT_SUCCESS
      })
      dispatch(getPaymentsList(isGroupLevel))
    } catch (error) {
      dispatch({
        type: a.UPDATE_PAYMENT_FAILED
      })
    }
  }
}
